var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.user)?_c('AppDrawer',{attrs:{"page":_vm.activePage}}):_vm._e(),_c('v-content',[(_vm.user)?_c('AppNavbar'):_vm._e(),_c('router-view')],1),_c('MessageBottomSheet')],1)}
var staticRenderFns = []

export { render, staticRenderFns }